<template>
  <div>
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="品牌">
              <el-select v-model="searchForm.brand" style="width: 120px" filterable clearable>
                <el-option v-for="b in brandList" :label="b.brand_name" :value="b.brand_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="getData"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="getData">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button icon="el-icon-plus" type="primary" @click="editRow(null)">添加风格</el-button>
            </el-form-item>
          </el-form>
          <div v-loading="loading" class="card-content">
            <el-table
              :data="tableData"
              stripe
              style="width: 100%;">
              <el-table-column
                label="图片"
                align="center"
                width="120">
                <template slot-scope="scope">
                  <el-image
                    :src="scope.row.imgurl"
                    fit="cover"
                    style="width: 40px;height: 40px;"
                    :preview-src-list="[scope.row.imgurl]"
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop="xuhao"
                label="优先级"
                width="100"
                align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="name"
                label="名称"
                width="140"
                align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="english"
                label="英文名"
                width="140"
                align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="brandname"
                label="品牌"
                min-width="200"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="操作"
                width="200"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button icon="el-icon-edit" size="mini" @click="editRow(scope.row)">修改</el-button>
                  <el-button icon="el-icon-delete" size="mini" @click="deleteRow(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="dialogVisible"
      width="400px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editForm" size="small" :model="editForm" label-width="80px" :rules="dilogrules" style="padding:15px 30px 15px 15px;">
        <el-form-item label="优先级" prop="xuhao">
          <el-input-number v-model="editForm.xuhao" :min="0" :max="999" ></el-input-number>
          <span style="color:#99a9bf;font-size:12px;margin-left: 10px">越小越优先</span>
        </el-form-item>
        <el-form-item label="品牌" prop="bid">
          <el-select v-model="editForm.bid" filterable clearable>
            <el-option v-for="b in brandList" :label="b.brand_name" :value="b.brand_id" />
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name" maxlength="10" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="英文名" prop="english">
          <el-input v-model="editForm.english" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="展示图片" prop="img">
          <span style="color:#99a9bf;"><i class="el-icon-warning"></i> 建议上传1:1的正方形图片</span>
          <SingleImg :key="imgkey" v-model="editForm.img" :oldurl="editForm.oldimgurl" :size="[200,200]" />
        </el-form-item>
        <el-form-item>
          <el-button :loading="eidtLoading" type="primary" @click="SubForm()">立即提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import SingleImg from '@/components/upload/SingleImg'
import { getWxStyleList, editWxStyle, delWxStyle, getBrandSeriesList } from '@/api/pub'

export default {
  name: 'fggl',
  components: {
    SingleImg
  },
  data() {
    return {
      brandList: [],
      searchForm: {
        brand: null,
        search: null
      },
      loading: false,
      tableData: [],
      dilogrules: {
        xuhao: [{ required: true, message: '请输入优先级', trigger: 'blur' }],
        bid: [{ required: true, message: '请选择品牌', trigger: 'change' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        english: [{ required: true, message: '请输入英文名', trigger: 'blur' }],
        img: [{ required: true, message: '请上传轮播图片', trigger: 'change' }]
      },
      editForm: {
        sid: 0,
        name: '',
        english: '',
        bid: null,
        xuhao: 0,
        img: null,
        oldimgurl: ''
      },
      skipid: null,
      editTitle: '',
      dialogVisible: false,
      eidtLoading: false,
      imgkey: '',
      bannerskipkey: ''
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getBrandList()
    this.getData()
  },
  methods: {
    getBrandList() {
      getBrandSeriesList().then(response => {
        let _brandList = []
        if (this.user.dGroupid === 1) { // 杭州乔金斯
          for (const b of response.data) {
            if (b.brand_id === 3) {
              _brandList.push(b)
            }
          }
        } else if (this.user.dGroupid === 2) { // 耐思迪
          for (const b of response.data) {
            if (b.brand_id === 1 || b.brand_id === 2) {
              _brandList.push(b)
            }
          }
        }
        this.brandList = _brandList
      })
    },
    getData() {
      this.loading = true
      const data = {
        search: this.searchForm.search,
        bid: this.searchForm.brand,
        fggroupid: this.user.dGroupid
      }
      getWxStyleList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    updatekey() {
      this.bannerskipkey = new Date().getTime().toString()
    },
    editRow(row) {
      if (row === null) {
        this.editTitle = '添加风格'
        this.editForm.sid = 0
        this.editForm.name = ''
        this.editForm.english = ''
        this.editForm.xuhao = 0
        this.editForm.img = null
        this.editForm.bid = null
        this.editForm.oldimgurl = ''
      } else {
        this.editTitle = '编辑风格'
        this.editForm.sid = row.sid
        this.editForm.name = row.name
        this.editForm.english = row.english
        this.editForm.xuhao = row.xuhao
        this.editForm.img = { imgid: row.imgid, imgurl: row.imgurl }
        this.editForm.oldimgurl = row.imgurl
        this.editForm.bid = row.bid
      }
      this.imgkey = (new Date().getTime() + 33).toString()
      this.dialogVisible = true
    },
    SubForm() {
      if (!this.eidtLoading) {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.eidtLoading = true
            const data = {
              sid: this.editForm.sid,
              name: this.editForm.name,
              imgid: this.editForm.img.imgid,
              english: this.editForm.english,
              bid: this.editForm.bid,
              xuhao: this.editForm.xuhao
            }
            editWxStyle(data).then(response => {
              this.eidtLoading = false
              this.$message({
                type: 'success',
                message: '提交成功'
              })
              this.getData()
              this.dialogVisible = false
            }).catch(() => {
              this.eidtLoading = false
            })
          }
        })
      }
    },
    deleteRow(row) {
      this.$confirm('您确定要删除此风格吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        delWxStyle({ sid: row.sid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>
